import { render, staticRenderFns } from "./RegisterWizardStepFour.vue?vue&type=template&id=21ff4cb5&scoped=true"
import script from "./RegisterWizardStepFour.vue?vue&type=script&lang=js"
export * from "./RegisterWizardStepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff4cb5",
  null
  
)

export default component.exports